import React, { useState, useEffect } from "react";

import Button from "@mui/material/Button";
import { grey } from "@mui/material/colors";

type Props = {
  onResend: VoidFunction;
  delay?: number;
};

const ResendButton: React.FC<Props> = ({ onResend, delay = 30 }) => {
  const [disabled, setDisabled] = useState(true);
  const [counter, setCounter] = useState(delay);

  useEffect(() => {
    if (disabled) {
      const timer = setTimeout(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [disabled, counter]);

  useEffect(() => {
    if (counter === 0) {
      setDisabled(false);
    }
  }, [counter]);

  const handleResend = () => {
    onResend();
    setDisabled(true);
    setCounter(delay);
  };

  return (
    <Button
      variant="text"
      sx={{
        ":disabled": {
          color: grey[500],
        },
      }}
      disabled={disabled}
      onClick={handleResend}
    >
      {disabled ? `Resend in ${counter}s` : "Resend OTP code"}
    </Button>
  );
};

export default ResendButton;
